import { Helmet } from 'react-helmet-async';

const CommunityPage = () => {
  return (
    <>
      <Helmet>
        <title>AI Community - AI News</title>
        <meta name="description" content="Connect with the AI community. Find forums, events, and job opportunities." />
        <meta name="keywords" content="AI community, AI forums, AI events, AI jobs, machine learning community" />
      </Helmet>
      <div className="container mx-auto p-4">
        <header className="my-8 text-center">
          <h1 className="text-4xl font-bold text-gray-100">AI Community</h1>
          <p className="text-lg text-gray-300 mt-2">Connect, learn, and grow with the AI community.</p>
        </header>
        
        <section className="text-center">
          <p className="text-xl text-gray-200">Community features coming soon!</p>
          <p className="text-md text-gray-400 mt-2">We are working on bringing you forums, event listings, and job boards. Stay tuned!</p>
        </section>
      </div>
    </>
  );
};

export default CommunityPage; 